import React from "react";
import TopicTable from "./components/TopicTable";

const HeaderContainer = (props) => {
    return <TopicTable/>
}

export default HeaderContainer;